import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type NoteColumnKey =
  | 'user'
  | 'content'
  | 'attachments'
  | 'created'
  | 'modified'
  | 'actions'

export const NOTES_COLUMNS: Record<NoteColumnKey, DataTypeColumn> = {
  user: {
    header: 'User',
    group: 'Note Details',
  },
  content: {
    header: 'Note',
    group: 'Note Details',
  },
  attachments: {
    header: 'Attachments',
    group: 'Note Details',
  },
  created: {
    header: 'Date Added',
    group: 'Dates',
  },
  modified: {
    header: 'Date Modified',
    group: 'Dates',
  },
  actions: {
    header: 'Actions',
    group: 'Actions',
  },
} satisfies Record<NoteColumnKey, DataTypeColumn>
